import React from "react"

export default function ({children}) {
  return <div style={{
    // scrollSnapAlign: "start"
  }}>{children}</div>
}